import BaseMove from "./base-move";
import {ActionTypeEnum} from "../../base/training-literals";

class MoveVolume extends BaseMove {
    modelId;
    volumeName;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.MOVE_VOLUME;
        this.modelId = props.modelId || "";
        this.volumeName = props.volumeName || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelId: props.modelId || this.modelId,
            volumeName: props.volumeName || this.volumeName,
            animateMovement: props.animateMovement || this.animateMovement,
            animateTime: props.animateTime || this.animateTime,
            position: props.position || this.position,
            quaternion: props.quaternion || this.quaternion,
            scale: props.scale || this.scale,
            duration: props.duration || this.duration
        }
    }

    startModelSelectionCallback(itemArr) {
        const actionId = itemArr[0];
        if (!this.shouldExecute(actionId)) return;

        this.startSelectionForMove();
    }

    startSelectionForMove() {
        this.startModelSelection = true;
        const applyToType = CatchTargetTypeEnum.VOLUME;
        VRMessageController.addMessage({
            text: "Select a volume to perform move volume.",
            priority: VrMessagePriorityEnum.WARNING
        });

        super.startSelectionForMove(applyToType);
    }

    selectEntityForEditingMove(entityName) {
        this.cancelSelection = false;
        this.startModelSelection = true;
        this.set2dElementsVisibility(false);
        CatchVolumeFeatureController.onChangeMoveFeature(true);
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.VOLUME);
        catchBody(undefined, undefined, undefined, undefined, {branchIdList: entityName});
        this.startModelSelection = false;
    }

    recordDataOnCatchBody(caughtVolume) {
        MoveObjectActionController.modelId = caughtVolume.model.id;
        MoveObjectActionController.modelName = caughtVolume.model.name;
        MoveObjectActionController.volumeName = caughtVolume.volumeList[0].name;
        MoveObjectActionController.branchId =  caughtVolume.branchIdList[0];

    }

    getData() {
        const currentVolumeLocalMatrix = getVolumeLocalMatrix(MoveObjectActionController.modelId, MoveObjectActionController.branchId);
        let position = new THREE.Vector3();
        let quaternion = new THREE.Quaternion();
        let scale = new THREE.Vector3();
        currentVolumeLocalMatrix.decompose(position, quaternion, scale);

        return {
            position: position.toArray(),
            quaternion: quaternion.toArray(),
            scale: scale.toArray()
        };
    }

    catchObjectToMove() {
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.VOLUME);
        catchBody(undefined, undefined, undefined, undefined,
            {branchIdList: [MoveObjectActionController.branchId]});
    }
}

export default MoveVolume;
